import {
    Box,
    Button,
    FormControl,
    Grid,
    InputLabel,
    ListSubheader,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import * as React from "react";
import { Units } from "./index";
import { Unit, UnitItem } from "./unit";

export interface WaveProps {
    wave: WaveItem;
    units: Units;
    waveAmount: number;

    onUpdateWaveDelay(waveId: number, delay: number);

    onRemoveWave(waveId: number);

    onSaveUnit(waveId: number, unit: UnitItem);

    onRemoveUnit(waveId: number, unit: UnitItem);
}

export interface WaveItem {
    id: number;
    delay: number;
    units: UnitItem[];

    currentUnit?: {
        id: number | null;
        level: number;
        amount: number;
    };
}

export class Wave extends React.Component<WaveProps, WaveItem> {

    constructor(props: WaveProps) {
        super(props);

        this.state = {
            id: this.props.wave.id,
            delay: this.props.wave.delay,
            units: this.props.wave.units,

            currentUnit: {
                id: null,
                level: 1,
                amount: 1
            }
        };
    }

    handleWaveDelayChange = (value) => {
        this.setState({
            delay: value
        });

        this.props.onUpdateWaveDelay(this.state.id, value);
    };

    handleCurrentUnitChange = (key: string, value: number) => {
        this.setState(state => {
            state.currentUnit[key] = value;

            return state;
        });
    };

    onSaveUnit = (unit: UnitItem) => this.props.onSaveUnit(this.state.id, unit);

    onRemoveUnit = (unit: UnitItem) => this.props.onRemoveUnit(this.state.id, unit);

    coordinatesFromPosition = (position: number) => ({
        x: Math.round(position % 46),
        y: Math.round(position / 46),
    });

    positionFromCoordinates = (x: number, y: number) => x + 46 * y;

    generatedMap = () => {
        const size = 46;
        const rows: any[] = [];

        for (let i = 0; i < size; i++) {
            const rowColumns: any[] = [];

            for (let j = 0; j < size; j++) {
                const cellPosition = (size * i) + j;

                const waveUnit = this.state.units.find(unit => unit.position === cellPosition);

                rowColumns.push(<Unit i={i} j={j} position={cellPosition} blocked={!waveUnit}
                                      units={this.props.units} unit={waveUnit} currentUnit={this.state.currentUnit}
                                      onSave={this.onSaveUnit} onRemove={this.onRemoveUnit}/>);
            }

            rows.push(<tr key={`row-${i}`}>{rowColumns}</tr>);
        }

        return <table className="player-map-table" style={{margin: "0 auto"}}>
            <tbody>
            {rows}
            </tbody>
        </table>;
    };

    render() {
        return <Box>
            {this.props.waveAmount > 1 &&
            <div style={{textAlign: "center", marginBottom: 20}}>
                <TextField
                    label="Delay to next wave"
                    value={this.state.delay}
                    onChange={(e) => this.handleWaveDelayChange(e.target.value)}
                    type="number"
                    margin="normal"
                    style={{margin: 0}}
                />

                <Button disableElevation onClick={() => this.props.onRemoveWave(this.state.id)} style={{margin: "5px 5px 0px 5px 10px"}}
                        variant="contained" color="secondary">
                    Remove this wave
                </Button>
            </div>
            }

            <div style={{flexGrow: 1}}>
                <Grid container>
                    <Grid item xs={10}>
                        {this.generatedMap()}
                    </Grid>
                    <Grid item xs={2}>
                        <FormControl style={{width: "100%", marginTop: 5}}>
                            <InputLabel>Unit</InputLabel>
                            <Select
                                value={this.state.currentUnit.id || ""}
                                onChange={(e) => this.handleCurrentUnitChange("id", parseInt(e.target.value as string, 10))}
                                style={{width: "100%"}}
                            >
                                <ListSubheader>Artillery</ListSubheader>
                                {(this.props.units.artillery || []).map(unit =>
                                    <MenuItem value={unit.id}>
                                        {unit.name}
                                    </MenuItem>
                                )}

                                <ListSubheader>Followers</ListSubheader>
                                {(this.props.units.followers || []).map(unit =>
                                    <MenuItem value={unit.id}>
                                        {unit.name}
                                    </MenuItem>
                                )}

                                <ListSubheader>Heroes</ListSubheader>
                                {(this.props.units.heroes || []).map(unit =>
                                    <MenuItem value={unit.id}>
                                        {unit.name}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>

                        <FormControl style={{width: "100%", marginTop: 5}}>
                            <TextField
                                label="Level"
                                type="number"
                                margin="normal"
                                value={this.state.currentUnit.level}
                                onChange={(e) => this.handleCurrentUnitChange("level", parseInt(e.target.value, 10))}
                                style={{margin: 0, width: "100%"}}
                            />
                        </FormControl>

                        <FormControl style={{width: "100%", marginTop: 5}}>
                            <TextField
                                label="Amount"
                                type="number"
                                margin="normal"
                                value={this.state.currentUnit.amount}
                                onChange={(e) => this.handleCurrentUnitChange("amount", parseInt(e.target.value, 10))}
                                style={{margin: 0, width: "100%"}}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </Box>;
    }
}
